import banner from '@/api/banners'
import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  banners: {},
  loadingBanners: false,
  bannerButtons: {},
  loadingBannerButtons: false
}

const getters = {
  getBannersForFairExplorePage: (state) => (fairExplorePath) => {
    return state.banners[fairExplorePath]
  }
}

const actions = {
  getBannerSetsForFairExplorePage ({ commit, state }, fairExplorePath) {
    return new Promise((resolve, reject) => {
      if (state.loadingBanners) {
        return
      }

      if (state.banners[fairExplorePath]) {
        resolve(state.banners[fairExplorePath])
        return
      }

      commit(types.LOADING_EXPLORE_PAGE_BANNER, true)
      banner.getBannerSetsForFairExplorePage(fairExplorePath).then((response) => {
        commit(types.ADD_EXPLORE_PAGE_BANNER, { fairExplorePath: fairExplorePath, banners: response.data.result.banners })
        commit(types.LOADING_EXPLORE_PAGE_BANNER, false)
        resolve(response.data.result.banners)
      }).catch(err => reject(err))
    })
  },
  getBannerButtonsForFairExplorePage ({ commit, state }, fairExplorePath) {
    return new Promise((resolve, reject) => {
      if (state.loadingBannerButtons) {
        return
      }

      if (state.bannerButtons[fairExplorePath]) {
        resolve(state.bannerButtons[fairExplorePath])
        return
      }

      commit(types.LOADING_EXPLORE_PAGE_BANNER_BUTTONS, true)
      banner.getBannerButtonsForFairExplorePage(fairExplorePath).then((response) => {
        commit(types.ADD_EXPLORE_PAGE_BANNER_BUTTONS, { fairExplorePath: fairExplorePath, bannerButtons: response.data.result.bannerButtons })
        commit(types.LOADING_EXPLORE_PAGE_BANNER_BUTTONS, false)
        resolve(response.data.result.bannerButtons)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {
  [types.ADD_EXPLORE_PAGE_BANNER] (state, { fairExplorePath, banners }) {
    Vue.set(state.banners, fairExplorePath, banners)
  },
  [types.LOADING_EXPLORE_PAGE_BANNER] (state, loading) {
    state.loadingBanners = loading
  },
  [types.ADD_EXPLORE_PAGE_BANNER_BUTTONS] (state, { fairExplorePath, bannerButtons }) {
    Vue.set(state.bannerButtons, fairExplorePath, bannerButtons)
  },
  [types.LOADING_EXPLORE_PAGE_BANNER_BUTTONS] (state, loading) {
    state.loadingBannerButtons = loading
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
